import React, { useEffect, useState } from 'react';
import VerificationImage from '../components/VerificationImageAndText';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import CustomToastContainer from '../components/CustomToastContainer';
import { verifyOtp } from '../apiServices/apiServices';
import { generateOtpMethod } from '../utils/otpUtils';


export default function OTPVerification() {
  const location = useLocation();
  const navigate = useNavigate();
  const data = location.state;

  const [timeLeft, setTimeLeft] = useState(59);

  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
      return () => clearInterval(timer);
    } 
  }, [timeLeft]);

  const handleResendOtp = async () => {
    // console.log("Resend")
    const generateOtpRequest = { id: data.data.id, isSignUp: data.isSignUp };
    await generateOtpMethod(generateOtpRequest);
  };
  
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
  };

  const validationSchema = Yup.object({
    otp1: Yup.string().required('Required').length(1, 'Must be 1 digit'),
    otp2: Yup.string().required('Required').length(1, 'Must be 1 digit'),
    otp3: Yup.string().required('Required').length(1, 'Must be 1 digit'),
    otp4: Yup.string().required('Required').length(1, 'Must be 1 digit'),
  });

  const formik = useFormik({
    initialValues: {
      otp1: '',
      otp2: '',
      otp3: '',
      otp4: '',
    },
    validationSchema,
    onSubmit: async (values) => {
      const enteredOtp = values.otp1 + values.otp2 + values.otp3 + values.otp4;
      // console.log("Data : ", data)
      const verifyOtpRequest = { id: data.data.id, otp: enteredOtp }; 
      // console.log("Verify Otp Request : ", verifyOtpRequest)

      try {
        const response = await verifyOtp(verifyOtpRequest);
        // console.log("Verify OTP Response : ", response);
        if (response && response.success) {
          toast.success('OTP Verified Successfully!');
          if(data.isSignUp)
          {
            navigate('/login');
          }
          else
          {
            navigate('/resetPassword', { state: response?.data?.passenger});
          }
        } else {
          toast.error('Invalid OTP. Please try again.');
        }
      } catch (error) {
        console.error('Error verifying OTP:', error);
        toast.error('An error occurred. Please try again.');
      }
    },
  });

  return (
    <>
      <div className="bg-gray-100 flex flex-col items-center justify-center h-screen p-4 md:p-10">
        <div className="w-full md:w-1/2 py-10 md:py-20">
          <div className="mb-10">
            <VerificationImage />
          </div>

          <h1 className="text-gray-500 font-semibold text-sm md:text-md text-center mb-8 md:mb-8">
            Input the verification code sent to <br />
            {data?.data?.phone} <br />
            OR <br />
            {data?.data?.email} <br />
          </h1>
          <div className="flex justify-center">
            <form onSubmit={formik.handleSubmit} className="flex flex-col space-y-4">
              <div className="flex flex-row items-center justify-center space-x-4">
                {['otp1', 'otp2', 'otp3', 'otp4'].map((name) => (
                  <input
                    key={name}
                    type="text"
                    name={name}
                    maxLength="1"
                    placeholder="0"
                    className="w-16 h-16 text-center text-2xl border-2 rounded-xl outline-none bg-gray-100 border-[#BE1F18]"
                    value={formik.values[name]}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                ))}
              </div>
              <button
                type="submit"
                className="bg-[#BE1F18] text-white hover:bg-opacity-90 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm w-full px-5 py-2.5 text-center"
              >
                Verify Account
              </button>

              {timeLeft > 0 ? (
                <div className="text-xs md:text-sm text-center block">
                  Resend code in <span className="text-[#BE1F18]">{formatTime(timeLeft)}</span>
                </div>
              ) : (
                <>
                   <button
                    type="button" 
                    onClick={handleResendOtp}
                    className="text-[#BE1F18] font-bold text-xs md:text-sm text-center mt-0"
                  >
                    Resend code
                  </button>
                  <h1 className="text-gray-600 font-semibold text-xs md:text-sm text-center mt-0">
                    Or
                  </h1>
                  <Link to="/contactUs" className="text-[#BE1F18] font-bold text-xs md:text-sm text-center mt-0">
                    Contact Us
                  </Link>
                </>
              )}
            </form>
          </div>
        </div>
      </div>
      <CustomToastContainer />
    </>
  );
}
